// Generated by Ktorfit
@file:Suppress("warnings")

package org.mifospay.core.network.services

import de.jensklingenberg.ktorfit.Ktorfit
import de.jensklingenberg.ktorfit.`internal`.ClassProvider
import de.jensklingenberg.ktorfit.`internal`.InternalKtorfitApi
import de.jensklingenberg.ktorfit.`internal`.KtorfitConverterHelper
import io.ktor.client.HttpClient
import io.ktor.client.request.HttpRequestBuilder
import io.ktor.client.request.parameter
import io.ktor.http.HttpMethod
import io.ktor.http.takeFrom
import io.ktor.util.reflect.typeInfo
import kotlin.OptIn
import kotlin.String
import kotlin.Suppress
import kotlin.collections.List
import kotlinx.coroutines.flow.Flow
import org.mifospay.core.network.model.twofactor.AccessToken
import org.mifospay.core.network.model.twofactor.DeliveryMethod

@OptIn(InternalKtorfitApi::class)
public class _TwoFactorAuthServiceImpl(
  private val _baseUrl: String,
  private val _httpClient: HttpClient,
  private val _helper: KtorfitConverterHelper,
) : TwoFactorAuthService {
  override suspend fun deliveryMethods(): Flow<List<DeliveryMethod>> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("GET")
        url{
        takeFrom(_baseUrl + "twofactor")
        } 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<Flow<List<DeliveryMethod>>>(),)!! 
  }

  override suspend fun requestOTP(deliveryMethod: String): Flow<String> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("POST")
        url{
        takeFrom(_baseUrl + "twofactor")
        deliveryMethod?.let{ parameter("deliveryMethod", "$it") }
        } 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<Flow<String>>(),)!! 
  }

  override suspend fun validateToken(token: String): Flow<AccessToken> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("POST")
        url{
        takeFrom(_baseUrl + "twofactor/validate")
        token?.let{ parameter("token", "$it") }
        } 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<Flow<AccessToken>>(),)!! 
  }
}

public class _TwoFactorAuthServiceProvider : ClassProvider<TwoFactorAuthService> {
  override fun create(_ktorfit: Ktorfit): TwoFactorAuthService = _TwoFactorAuthServiceImpl(_ktorfit.baseUrl, _ktorfit.httpClient, KtorfitConverterHelper(_ktorfit))
}

public fun Ktorfit.createTwoFactorAuthService(): TwoFactorAuthService = _TwoFactorAuthServiceImpl(this.baseUrl, this.httpClient, KtorfitConverterHelper(this))
